// extracted by mini-css-extract-plugin
export var navLink = "DropdownMobile-module--navLink--c07dc";
export var navMenu = "DropdownMobile-module--navMenu--8861d";
export var navbarMargin = "DropdownMobile-module--navbarMargin--03c79";
export var revealContent = "DropdownMobile-module--reveal-content--d1ecc";